import classNames from 'classnames';
import { FC, ReactNode, memo } from 'react';
import '../styles.css';

interface HeaderProps {
  children: ReactNode;
  accountHeader?: boolean;
  hideHeaderInAccountDesctopView?: boolean;
  additionalClassName?: string;
  accountHeaderChildren?: ReactNode;
}

const _Header: FC<HeaderProps> = ({
  children,
  accountHeader = false,
  additionalClassName,
  accountHeaderChildren
}) => {
  return (
    <div
      className={classNames(
        'w-full sticky top-0 left-0 right-0 header-shadow',
        additionalClassName
      )}>
      <header
        className={classNames(
          'flex justify-center items-center header-container',
          accountHeader ? 'flex-col lg:flex-row lg:h-[unset]' : ''
        )}>
        <div
          className={classNames(
            accountHeader ? 'h-full lg:pt-0' : 'h-full',
            'w-full flex flex-col justify-center items-center'
          )}>
          {children}
        </div>
        {accountHeader ? (
          <div className="flex lg:hidden w-full justify-center items-center bg-h_bg">
            {accountHeaderChildren}
          </div>
        ) : null}
      </header>
    </div>
  );
};

export const Header = memo(_Header);
